import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Container,
  ImageListItem,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import "./BuyerGuiForWhom.css";
import styled from "styled-components";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import Background from "../assets/images/xWerkbon-2.jpg.pagespeed.ic.oKaJgNpGNo.jpeg";

const MainComponent = styled.div`
  background-color: #fff;
  padding: 2%;
  border-radius: 18px;
`;

const Title = styled.h1`
  font-size: 30px;
  color: #00008b;
  font-weight: 500;
  font-family: Poppins;
  line-height: 1.5;
  letter-spacing: 0.00938em;
`;

const ParaTitle = styled.h4`
  margin: 0;
  color: #494949;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  font-family: Poppins;
`;

const AvatarStyled = styled.div`
  width: 28px;
  height: 28px;
  font-size: 1.25rem;
  line-height: 1;
  border-radius: 50%;
  background-color: #e9edf5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function AfterCareAdvantages() {
  const { t } = useTranslation();
  return (
    <>
      <Container maxWidth="xl" sx={{ zIndex: 5 }}>
        <Box padding={{ xs: 0, sm: 5, md: 7 }}>
          <Grid
            className="last_grid"
            container
            rowSpacing={1}
            sx={{
              px: { xs: "10px", sm: "10px", md: 7 },
              display: "flex",
              flexDirection: {
                xs: "column-reverse",
                sm: "column-reverse",
                md: "column-reverse",
                lg: "row",
              },
            }}
          >
            <Grid item xs={12} md={12} lg={6}>
              <MainComponent>
                <Title className="typo_title">
                  {t("general.advantages.title")}
                </Title>
                <List>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.1")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.2")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.3")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.4")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.5")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.6")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.7")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.8")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.9")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.10")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                  <ListItem sx={{ px: { xs: 0, sm: 0, md: 2 } }}>
                    <ListItemIcon>
                      <AvatarStyled>
                        <CheckIcon />
                      </AvatarStyled>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <ParaTitle className="typo_title2">
                            {t("modules.aftercare.advantages.11")}
                          </ParaTitle>
                        </React.Fragment>
                      }
                      secondary=""
                    />
                  </ListItem>
                </List>
              </MainComponent>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              lg={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <ImageListItem sx={{ maxWidth: "625px" }}>
                <img
                  style={{
                    maxHeight: "500px",
                    borderRadius: "25px",
                    boxShadow: "rgb(255 255 255) 15px 2px 30px 10px",
                  }}
                  src={Background}
                  alt="Kopersbegeleiding"
                />
              </ImageListItem>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}
